module.exports = __webpack_public_path__ + "img/edge_activites_rails.2bbbe7b5.svg";